import { render } from "./Popup.vue?vue&type=template&id=1236f2a4&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=1236f2a4&lang=scss&scoped=true"

import exportComponent from "D:\\development\\castorama\\bathroom-web2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1236f2a4"]])

export default __exports__